// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"350": "8d1160dd01eb45c9","397": "1fd56a0d00bb73eb",}[chunkId] + ".css"
}